import { PRINT_HYPHEN } from '../constants';

// eslint-disable-next-line
export const formatNullToHyphen = (value: any): string | number => {
  if (value === null) {
    return PRINT_HYPHEN;
  }
  return value;
};
